import React, { useState, useEffect, useRef } from "react";
import { AgGridReact } from "ag-grid-react";
import ImportGlossary from "./ImportGlossary";
import GlossaryText from "./GlossaryText";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import "semantic-ui-css/semantic.min.css";

import {
  Button,
  Modal,
  Form,
  Input,
  Icon,
  Dimmer,
  Loader,
  Header,
  Checkbox,
  Select,
  Message,
} from "semantic-ui-react";
import { axiosInstance } from "../../fetcher";
import { APP_SETTINGS } from "../../env";

const style = {
  dropDownL: {
    padding: "8px",
    fontSize: "14px",
    borderRadius: "5px",
    border: "1px solid #ccc",
    backgroundColor: "#fff",
  },
};


const GlossaryTable = () => {
  const [deleteModalState, setDeleteModalState] = useState(false);
  const [selectedRowsPrivate, setSelectedRowsPrivate] = useState([]);
  const [addModalState, setAddModalState] = useState(false);
  const [addConfirmationModalOpen, setAddConfirmationModalOpen] =
    useState(false);
  const [sourceValueAdd, setSourceValueAdd] = useState("");
  const [targetValueAdd, setTargetValueAdd] = useState("");
  const [addRecordsLoader, setAddRecordsLoader] = useState(false);
  const [privateData, setPrivateData] = useState([]);
  const [deleteRecordsLoader, setDeleteRecordsLoader] = useState(false);
  const [getRecordsLoader, setRecordsLoader] = useState(false);
  const [defaultColDef, setDefaultColDef] = useState([
    { sortable: true, resizable: true, filter: true, flex: 1, minWidth: 100 },
  ]);

  const [columnDefsPublic, setColumnDefsPublic] = useState([
    {
      headerName: "Source Terms",
      field: "Term",
      width: 230,
      headerCheckboxSelection: true,
      checkboxSelection: true,
      headerCheckboxSelectionFilteredOnly: true,
    },
    { headerName: "Target Terms", field: "Translation", width: 230 },
    { headerName: "Source Language", field: "SourceLanguage", width: 230 },
    { headerName: "Target Language", field: "TargetLangauge", width: 230 },
    { headerName: "Engagement", field: "EngagementID", width: 230 },
  ]);

  const [languageList, setLanguageList] = useState([]);
  const [sourceLanguage, setSourceLanguage] = useState("default");
  const [targetLanguage, setTargetLanguage] = useState("default");
  const [addResultState, setAddResultState] = useState(false);

  const [engagementName, setEngagementName] = useState("");
  
  const currentDomain = window.location.hostname.split(".")[1];

  let endpointToUse;

  if (currentDomain === "azurewebsites") {
    endpointToUse = new URL(APP_SETTINGS.public_endpoint).origin;
  } else {
    endpointToUse = new URL(APP_SETTINGS.private_endpoint).origin;
  }
  const currentUrl = endpointToUse;
  const gridRef = useRef();

  useEffect(() => {
    
    fetchGlossaryData();
    fetchSupportedLanguages();
  }, []);

  const checkparam = async () => {
    try {
      // const responseEngagementName = await axiosInstance.get(
      //   "/get_engagement_name"
      // );
      const responseEngagementName = await axiosInstance.post(
              "/engagements/get_engagements_name", { url: currentUrl }
            );
      console.log("Engagement name received is:- ", responseEngagementName.data.engagement_name);
      setEngagementName(responseEngagementName.data.engagement_name);
      // console.log("OS Param value is - ", responseEngagementName.data);
    } catch (error) {
      console.error("Error fetching supported languages:", error);
    }
  };

  const fetchGlossaryData = async () => {
    try {
      setRecordsLoader(true);
      setSelectedRowsPrivate([]);
      // const responseEngagementName = await axiosInstance.get(
      //   "/get_engagement_name"
      // );

      const responseEngagementName = await axiosInstance.post(
        "/engagements/get_engagements_name", { url: currentUrl }
      );

      setEngagementName(responseEngagementName.data.engagement_name);
      // console.log("Engagement name received is:- ", engagementName);
      const response = await axiosInstance.post(`/glossary/get_glossary_data`, {
        engagementName: responseEngagementName.data.engagement_name,
      });
      console.log("Glossary data received is:- ", response.data);
      console.log("engagementName is:- ", engagementName);
      const glossaryData = response.data;
      if (glossaryData) {
        setPrivateData(glossaryData);
        setRecordsLoader(false);
      }
    } catch (error) {
      console.error("Error fetching supported languages:", error);
    }
  };

  const fetchSupportedLanguages = async () => {
    try {
      const response = await axiosInstance.get(
        "/glossary/get_supported_languages"
      );
      if (response.data.data.languages) {
        setLanguageList(response.data.data.languages);
      }
    } catch (error) {
      console.error("Error fetching supported languages:", error);
    }
  };

  const handleInsertion = async () => {
    const addGlossary = {
      term: sourceValueAdd,
      translation: targetValueAdd,
      sourceLanguage: sourceLanguage,
      targetLanguage: targetLanguage,
    };
    try {
      setAddRecordsLoader(true);

        // Correct API call (removing unnecessary input_data wrapper)
        const response = await axiosInstance.post(
        `/glossary/insert_record`,
            {"input_data" :addGlossary,
              "engagementName": engagementName,
            } // Send object directly, no need for "input_data"
      );

        if (response.data.data === "Record Inserted Succesfully") {
            fetchGlossaryData(); // Refresh data
        setAddModalState(false);
        setAddRecordsLoader(false);
        setAddResultState(true);
        setAddConfirmationModalOpen(false);
        } else if (response.data.data === "Duplicate") {
        fetchGlossaryData();
        setAddModalState(true);
        setAddRecordsLoader(false);
        setAddResultState(false);
        setAddConfirmationModalOpen(true);
      }

        // Reset dropdowns
      setSourceLanguage("default");
      setTargetLanguage("default");
    } catch (error) {
        console.error("Error inserting record:", error);
        setAddRecordsLoader(false);
    }
  };

  const onSelectionChanged = () => {
    const selectedRows = gridRef.current.api.getSelectedRows();
    setSelectedRowsPrivate(selectedRows);
  };

  const deletePrivaterecords = async () => {
    try {
      setRecordsLoader(true);
      const deletePayload = {
        input_data: selectedRowsPrivate.map(row => ({
          Id: row.Id,
          Translation: row.Translation,
          SourceLanguageOriginal: row.SourceLanguageOriginal,
          TargetLanguageOriginal: row.TargetLanguageOriginal
        })),
        engagementName: engagementName
      };

      const response = await axiosInstance.post(`/glossary/delete_record`, deletePayload);
      
      if (response.data) {
        fetchGlossaryData();
        setRecordsLoader(false);
      }
    } catch (error) {
      console.error("Error deleting records:", error);
      setRecordsLoader(false);
    }
  };

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        width: "100%",
        position: "relative",
        left: "auto",
        overflow: "hidden",
        "margin-left": "0.5rem",
      }}
    >
      {/* Button Group */}
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          width: "775px",
        }}
      >
        {/* Edit Glossary */}

        {localStorage.getItem("isAdmin") === "true" && (
          <>
            <div>
              <GlossaryText
                selectedRowsPrivate={selectedRowsPrivate}
                fetchGlossaryData={fetchGlossaryData}
              />
            </div>
 
            {/* Delete Records */}
            <div>
              <Modal
                basic
                size="small"
                style={{
                  position: "absolute",
                  top: "25%",
                  left: "25%",
                  transform: "transform(-50%, -50%)",
                  width: "700px",
                  height: "auto",
                }}
                onClose={() => setDeleteModalState(false)}
                onOpen={() => setDeleteModalState(true)}
                open={deleteModalState}
                trigger={
                  <button
                    type="button"
                    className="btn btn-primary btn-md rounded-pill"
                    style={{
                      color: "white",
                      margin: "11px",
                      background:
                        selectedRowsPrivate.length > 0
                          ? "#00e6e3"
                          : "lightgray",
                    }}
                    disabled={selectedRowsPrivate.length !== 1}
                  >
                    <Icon name="delete" />
                    Delete Record
                  </button>
                }
              >
                <Header icon>
                  <Icon name="archive" />
                  Delete Record
                </Header>
                <Modal.Content>
                  <p>Confirm deletion of Record</p>
                </Modal.Content>
                <Modal.Actions>
                  <Button
                    basic
                    color="red"
                    onClick={() => setDeleteModalState(false)}
                  >
                    <Icon name="remove" /> No
                  </Button>
                  <Button
                    color="green"
                    onClick={() => {
                      setDeleteModalState(false);
                      deletePrivaterecords();
                    }}
                  >
                    <Icon name="checkmark" /> Yes
                  </Button>
                  <Dimmer active={deleteRecordsLoader}>
                    <Loader inline active={deleteRecordsLoader} />
                  </Dimmer>
                </Modal.Actions>
              </Modal>
            </div>
          </>
        )}
 
        {/* Add Glossary */}
        <div>
          <Modal
            style={{
              border: "1px black solid",
              position: "absolute",
              top: "16%",
              left: "25%",
              transform: "transform(-50%, -50%)",
              width: "700px",
              height: "auto",
            }}
            onClose={() => setAddModalState(false)}
            onOpen={() => setAddModalState(true)}
            open={addModalState}
            trigger={
              <button
                type="button"
                className="btn btn-primary btn-md rounded-pill"
                style={{
                  color: "white",
                  margin: "11px",
                  background: "#00e6e3",
                }}
              >
                <Icon name="add" />
                Add Record
              </button>
            }
          >
            <Modal.Header>Add Glossary Record</Modal.Header>
            <Modal.Content>
              <Form>
                <Form.Field required>
                  <label>Source</label>
                  <Input
                    icon="language"
                    iconPosition="left"
                    placeholder="Source definition"
                    error={sourceValueAdd === ""}
                    onChange={(e, data) => setSourceValueAdd(data.value)}
                  />
                </Form.Field>
                <Form.Field required>
                  <label>Target</label>
                  <Input
                    icon="language"
                    iconPosition="left"
                    placeholder="Target definition"
                    error={targetValueAdd === ""}
                    onChange={(e, data) => setTargetValueAdd(data.value)}
                  />
                </Form.Field>

                <Form.Field required>
                  <div>
                    <label
                      htmlFor="sourceLanguage"
                      style={{ marginRight: "10px" }}
                    >
                      <b>Source Language </b>
                    </label>
                    <select
                      id="sourceLanguage"
                      name="sourceLanguage"
                      value={sourceLanguage}
                      onChange={(e) => setSourceLanguage(e.target.value)}
                      className="dropdown-select"
                      style={style.dropDownL}
                    >
                      <option key="default" value="default">
                        {" "}
                        -- Select Source Language --{" "}
                      </option>
                      {languageList
                        .filter((ele) => ele.languageCode !== "auto")
                        .sort((a, b) =>
                          a.languageName.localeCompare(b.languageName)
                        )
                        .map((language) => (
                          <option
                            key={language.languageCode}
                            value={language.languageCode}
                          >
                            {language.languageName}
                          </option>
                        ))}
                    </select>
                  </div>
                </Form.Field>
                <Form.Field required>
                  <div>
                    <label
                      htmlFor="targetLanguage"
                      style={{ marginRight: "10px" }}
                    >
                      <b>Target Language </b>
                    </label>
                    <select
                      id="targetLanguage1"
                      name="targetLanguage"
                      value={targetLanguage}
                      onChange={(e) => setTargetLanguage(e.target.value)}
                      className="dropdown-select"
                      style={style.dropDownL}
                    >
                      <option key="default" value="default">
                        {" "}
                        -- Select Target Language --{" "}
                      </option>
                      {languageList
                        .filter((ele) => ele.languageCode !== "auto")
                        .sort((a, b) =>
                          a.languageName.localeCompare(b.languageName)
                        )
                        .map((language) => (
                          <option
                            key={language.languageCode}
                            value={language.languageCode}
                          >
                            {language.languageName}
                          </option>
                        ))}
                    </select>
                  </div>
                </Form.Field>
              </Form>
            </Modal.Content>
            <Modal.Actions>
              <Button
                color="black"
                onClick={() => {
                  setAddModalState(false);
                  setSourceLanguage("default");
                  setTargetLanguage("default");
                  setSourceValueAdd("");
                  setTargetValueAdd("");
                }}
              >
                Cancel
              </Button>
              <Button
                disabled={
                  sourceLanguage == "default" ||
                  targetLanguage == "default" ||
                  targetValueAdd == "" ||
                  sourceValueAdd == ""
                    ? true
                    : false
                }
                content="Add"
                labelPosition="right"
                icon="save"
                onClick={() => {
                  setAddRecordsLoader(true);
                  handleInsertion();
                }}
                positive
              />
              <Dimmer active={addRecordsLoader}>
                <Loader inline="centered" active={addRecordsLoader} />
              </Dimmer>
            </Modal.Actions>
            <Modal
              style={{
                border: "1px black solid",
                position: "absolute",
                top: "35%",
                left: "35%",
                transform: "transform(-50%, -50%)",
                width: "400px",
                height: "auto",
              }}
              onClose={() => setAddConfirmationModalOpen(false)}
              open={addConfirmationModalOpen}
              size="small"
            >
              <Modal.Header>Insertion Status</Modal.Header>
              <Modal.Content>
                <div>
                  {addResultState ? (
                    <Message positive>
                      <Message.Header>Success</Message.Header>
                      <p>
                        Record has been <b>Inserted Successfully</b>
                      </p>
                    </Message>
                  ) : (
                    <Message
                      error
                      header="Duplicate Record Found"
                      list={[
                        "Try to modify existing record by editing it.",
                        "Try deleting existing record.",
                      ]}
                    />
                  )}
                </div>
              </Modal.Content>
              <Modal.Actions>
                <Button
                  icon="check"
                  content="OK"
                  onClick={() => {
                    setAddConfirmationModalOpen(false);
                    setAddModalState(false);
                  }}
                />
              </Modal.Actions>
            </Modal>
          </Modal>
        </div>
      </div>
      <div>
        {
          <div
            className="ag-theme-alpine"
            style={{
              height: "520px",
              width: "96%",
            }}
          >
            <Dimmer
              active={getRecordsLoader}
              style={{
                // width: '100px',
                // height: '100px',
                // margin: '140px',
                display: "flex",
                justifyContent: "left",
                alignItems: "center",
                // background: 'Grey',
              }}
            >
              <Loader inline active={getRecordsLoader} />

              <span>Loading...</span>
            </Dimmer>
            {privateData &&
 
            <AgGridReact
              ref={gridRef}
              columnDefs={columnDefsPublic}
              rowData={privateData}
              defaultColDef={defaultColDef}
              onSelectionChanged={() => onSelectionChanged()}
              rowSelection="single"
              paginationPageSize={10}
              pagination={true}
              suppressRowClickSelection={true}
            ></AgGridReact>
            }

          </div>
        }
      </div>
    </div>
  );
};

export default GlossaryTable;
